
import {throwError as observableThrowError,  Observable ,  BehaviorSubject } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { Injectable, Provider } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from '../../../environments/environment';

//INTERFACES
import { Login } from '../interfaces/login';

@Injectable()
export class LoginService {

//SUBSCRIBTION DER ANGIVER OM BRUGEREN ER LOGGET IND
private loggedInSource = new BehaviorSubject<boolean>(false);
loggedIn$: Observable<boolean> = this.loggedInSource.asObservable();

//SUBSCRIBTION DER ANGIVER BRUGERTYPE
private userTypeSource = new BehaviorSubject<string>("");
userType$: Observable<string> = this.userTypeSource.asObservable();

//jwtHelper: JwtHelper = new JwtHelper();
jwtHelper: JwtHelperService = new JwtHelperService();

constructor(private _http: HttpClient, private _router: Router) {

     //LOGIK DER TJEKKER OM BRUGEREN HAR EN TOKEN DER IKKE ER EXPIRED VED RELOAD AF SIDE
     if (localStorage.getItem('access_token')) {
        var decoded = this.jwtHelper.decodeToken(localStorage.getItem('access_token'));
        if (!this.jwtHelper.isTokenExpired(localStorage.getItem('access_token'))) {
            this.loggedInSource.next(true);
            if (decoded.userType) {
                this.userTypeSource.next(decoded.userType);
            }
        }
        else if (this.jwtHelper.isTokenExpired(localStorage.getItem('access_token'))) {
            //this._messageBoxService.createMessageboxWarning('Du har været inaktiv mere end 30 min og er derfor blevet logget ud !');
        }
        else {                
            this._router.navigateByUrl('/courses');
        }
    }
}

login(_login: Login) {
    const httpOptions = {
        headers: new HttpHeaders({
            'accept': 'application/json',
            'accept-language': 'null',
            'content-type': 'application/x-www-form-urlencoded'
  })
};
    //Headers variabel skabes
    const headers = new HttpHeaders().set('accept', 'application/json').set('accept-language', 'null').set('content-type', 'application/x-www-form-urlencoded');
    //HTTP headers tilføjes
    // headers = headers.append('accept', 'application/json');
    // headers = headers.append('accept-language', 'null');
    // headers = headers.append('content-type', 'application/x-www-form-urlencoded');
    //HTTP body laves
    var body = 'grant_type=password&username=' + _login.userName + '&password=' + _login.password;
    console.log(headers);
    return this._http.post(environment.tokenURL, body, httpOptions ).toPromise().then((res:any) => {
        if (res.access_token) {
            //Access token gemmes i lokal storage
            localStorage.setItem('access_token', res.access_token);
            //logged in sættes til true
            this.loggedInSource.next(true);
            //Response success settes til true
            res.success = true;
            var decoded = this.jwtHelper.decodeToken(res.access_token);
            if (decoded.userType) {
                this.userTypeSource.next(decoded.userType);
            }
        }
        //Response returneres
        return res.success;
    }, error => { console.log(error)});
    }
    //LOGGER BRUGER UD
    logout() {
        //Access token slettes fra lokal storage
        localStorage.removeItem('access_token');
        //logged in sættes til false
        this.loggedInSource.next(false);
        this.userTypeSource.next('');
    }   
    //RETURNERE TOKEN
    getToken() {
        return localStorage.getItem('access_token');
    }
    //RETURNERE OM BRUGER ER LOGGET IND
    isAuthenticated() {
        // const user = JSON.parse(localStorage.getItem('username'));
        // const token = user ? (user.token ? user.token : null) : null;
        // return token ? (this.jwtHelper.isTokenExpired(localStorage.getItem('access_token')) ? false : true) : false;
        if (localStorage.getItem('access_token')){
            const token = localStorage.getItem('access_token');
            return !this.jwtHelper.isTokenExpired(token);
        }
        return false;        
    }
    //RETURNERE BRUGERROLLE
    isAdmin() {
        if (localStorage.getItem('access_token')) {
            if (!this.jwtHelper.isTokenExpired(localStorage.getItem('access_token'))) {
                var token = localStorage.getItem('access_token');
                var decoded = this.jwtHelper.decodeToken(token);
                if (decoded.admin == 1){
                    return true;
                }
                else{
                    return false;
                }
            }
            else{
                return false;
            }        
        }
        else{
            return false;
        }
        
        
    }
    //RETURNERE DEN INDLOGGEDE BRUGERS BRUGERNAVN FRA TOKEN
    getUserName() {
        if (this.isAuthenticated) {
            var token = localStorage.getItem('access_token');
            var decoded = this.jwtHelper.decodeToken(token);

            return decoded.username;
        }
        return "";
    }
    //RETURNERE DEN INDLOGGEDE BRUGERS USERID FRA TOKEN
    getUserID() {
        if (this.isAuthenticated) 
        {
            var token = localStorage.getItem('access_token');
            var decoded = this.jwtHelper.decodeToken(token);
            return decoded.userID;
        }
        return "";
    }
}
